export default __webpack_public_path__ + "static/media/houseimage2.d54b2ee3.png";